import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { MenuItemConfig } from 'types/Common.types';
import { RowActionsCellRendererProps } from 'types/ScenarioManagement.types';

/**
 * Renders the row-level actions for a scenario AGGrid row.
 * @param data
 * @param onDelete
 * @constructor
 */
const RowActionsCellRenderer = ({ data, onDelete }: RowActionsCellRendererProps) => {
  /**
   * Handles deleting the entry.
   */
  const handleDelete = () => {
    if (onDelete && data?.metadata?.internalId) {
      onDelete(!!data?.metadata?.isNewRow, data?.metadata?.internalId);
    }
  };

  /**
   * MenuItem list for the row-level actions.
   */
  const menuItems: MenuItemConfig[] = [
    {
      id: 'delete',
      label: 'Delete',
      icon: <DeleteIcon fontSize='small' />,
      className: 'delete-icon',
      action: handleDelete, // TODO: Consider using a Confirm Dialog for this action (TOC has one)
    },
  ];

  // NOTE: For details on PopupState, see: https://mui.com/material-ui/react-menu/#material-ui-popup-state
  return (
    <PopupState variant='popover' popupId='actions-menu'>
      {(popupState) => (
        <>
          <IconButton {...bindTrigger(popupState)} className='menu-button' size='small'>
            <MoreHorizIcon fontSize='inherit' />
          </IconButton>
          <Menu className='menu-dropdown' {...bindMenu(popupState)}>
            {menuItems.map((item) => (
              <MenuItem
                key={item.id}
                className='menu-item'
                onClick={() => {
                  item.action();
                  popupState.close();
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText>
                  <Typography noWrap>{item.label}</Typography>
                </ListItemText>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default RowActionsCellRenderer;
